<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="手机号" prop="mobile" >
        <a-input disabled v-model="form.mobile" />
      </a-form-model-item>
      <a-form-model-item label="邮箱" prop="email" >
        <a-input disabled v-model="form.email" />
      </a-form-model-item>
      <a-form-model-item label="头像链接" prop="avatar" >
        <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="form.avatar"
             :src="processImageUrl(form.avatar)" preview="头像"/>
      </a-form-model-item>
      <a-form-model-item label="昵称" prop="nickname" >
        <a-input disabled v-model="form.nickname" placeholder="请输入昵称" />
      </a-form-model-item>
      <a-form-model-item label="性别" prop="sex" >
        <a-select disabled v-model="form.sex">
          <a-select-option :value="0">保密</a-select-option>
          <a-select-option :value="1">男</a-select-option>
          <a-select-option :value="2">女</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="状态" prop="status" >
        <a-select  v-model="form.status">
          <a-select-option :value="0">禁用</a-select-option>
          <a-select-option :value="1">正常</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="生日" prop="birthday" v-if="form.birthday">
        <a-input disabled v-model="form.birthday" placeholder="请输入生日" />
      </a-form-model-item>

      <a-form-model-item label="用户个性签名" prop="userSign" v-if="form.userSign">
        <a-input disabled v-model="form.userSign" placeholder="请输入用户个性签名" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button  type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUser, addUser, updateUser } from '@/api/user/user'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        mobile: null,

        email: null,

        password: null,

        avatar: null,

        nickname: null,

        sex: null,

        birthday: null,

        userSign: null,

        invitationCode: null,

        isNotice: null,
        userLevel:null,

        status: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {}
    }
  },
  filters: {
  },
  created () {

  },
  activated() {

  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    processImageUrl,
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.isInfo = false
      this.form = {
        id: null,
        mobile: null,
        password: null,
        avatar: null,
        nickname: null,
        sex: null,
        birthday: null,
        userLevel:null,
        userSign: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUser({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '审核'
      })
    },

    handleInfo(row){
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUser({"id":id}).then(response => {
        this.form = response.data
        this.isInfo = true
        this.open = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUser(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUser(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
